/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".box-parent[_ngcontent-%COMP%] {\n  background: #ffffff;\n  padding: 20px 20px 30px 20px;\n  border-radius: 10px;\n  box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.2); }"];
export { styles as styles };



// WEBPACK FOOTER //
// /opt/app/src/app/features/dashboard/dashboard-list/dashboard-list.component.scss.shim.ngstyle.js.pre-build-optimizer.js